/* ============================================================
   custom-audit-fixes.js
   Runtime fixes for inline-styled page content that CSS cannot
   override (inline !important wins over external !important).
   ============================================================ */
(function () {
  'use strict';

  /* --- URL redirects for old/mistyped page handles --- */
  var redirects = {
    '/pages/about': '/pages/our-story'
  };
  var path = window.location.pathname.replace(/\/+$/, '');
  if (redirects[path]) {
    window.location.replace(redirects[path]);
    return;
  }

  var MOBILE_BREAKPOINT = 749;

  function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function fixRteContainers() {
    // Force .rte rich-text containers to stack their children
    // full-width on mobile. The wholesale page content uses
    // display:flex on .rte which leaves boxes stuck in narrow
    // columns on phones.
    var rtes = document.querySelectorAll('.rte');
    rtes.forEach(function (rte) {
      if (isMobile()) {
        if (!rte.dataset.origDisplay) {
          rte.dataset.origDisplay = rte.style.display || '';
          rte.dataset.origFlexDir = rte.style.flexDirection || '';
        }
        rte.style.setProperty('display', 'block', 'important');
        rte.style.setProperty('overflow-x', 'hidden', 'important');
        rte.style.setProperty('max-width', '100%', 'important');
        // Force direct children (inline-styled boxes) to full width
        [].forEach.call(rte.children, function (child) {
          if (child.tagName === 'DIV') {
            if (!child.dataset.origWidth) {
              child.dataset.origWidth = child.style.width || '';
              child.dataset.origMaxWidth = child.style.maxWidth || '';
              child.dataset.origFlex = child.style.flex || '';
              child.dataset.origPadding = child.style.padding || '';
            }
            child.style.setProperty('width', '100%', 'important');
            child.style.setProperty('max-width', '100%', 'important');
            child.style.setProperty('flex', '0 0 100%', 'important');
            child.style.setProperty('box-sizing', 'border-box', 'important');
            child.style.setProperty('min-width', '0', 'important');
            // Shrink large inline padding on mobile so content fits
            var pad = getComputedStyle(child).padding;
            if (parseInt(pad) > 30) {
              child.style.setProperty('padding', '28px 20px', 'important');
            }
          }
        });
      } else if (rte.dataset.origDisplay !== undefined) {
        rte.style.display = rte.dataset.origDisplay;
        rte.style.flexDirection = rte.dataset.origFlexDir;
        [].forEach.call(rte.children, function (child) {
          if (child.dataset.origWidth !== undefined) {
            child.style.width = child.dataset.origWidth;
            child.style.maxWidth = child.dataset.origMaxWidth;
            child.style.flex = child.dataset.origFlex;
          }
        });
      }
    });
  }

  function fixInlineGrids() {
    // Find every container with inline grid-template-columns set to
    // a two-column layout and collapse it to single-column on mobile.
    var grids = document.querySelectorAll(
      'div[style*="grid-template-columns"], section[style*="grid-template-columns"]'
    );
    grids.forEach(function (el) {
      var style = el.getAttribute('style') || '';
      var hasTwoCol = /grid-template-columns\s*:\s*(?:1fr\s+1fr|repeat\(\s*2\s*,[^)]+\))/i.test(style);
      if (!hasTwoCol) return;
      if (isMobile()) {
        if (!el.dataset.origGridCols) {
          el.dataset.origGridCols = style;
        }
        el.style.setProperty('grid-template-columns', '1fr', 'important');
        el.style.setProperty('gap', '20px', 'important');
        el.style.setProperty('max-width', '100%', 'important');
      } else if (el.dataset.origGridCols) {
        el.setAttribute('style', el.dataset.origGridCols);
      }
    });
  }

  function equalizeButtonGroups() {
    // Find adjacent inline-styled anchor buttons inside .rte blocks
    // and make them share the same width so button pairs align.
    var rtes = document.querySelectorAll('.rte');
    rtes.forEach(function (rte) {
      if (rte.closest('.article-template')) return; // skip blog posts
      // Collect contiguous runs of inline-styled <a> elements
      var anchors = rte.querySelectorAll('a[style*="padding"], a[style*="background"], a.button, a[href*="sample"], a[href*="partner"]');
      if (anchors.length < 2) return;
      // Group anchors that share the same parent
      var groups = {};
      anchors.forEach(function (a) {
        var key = a.parentElement ? a.parentElement : rte;
        var id = key.dataset.__btnGroupId || (key.dataset.__btnGroupId = Math.random().toString(36).slice(2, 8));
        (groups[id] = groups[id] || []).push(a);
      });
      Object.keys(groups).forEach(function (id) {
        var group = groups[id];
        if (group.length < 2) return;
        // Find widest natural width (with nowrap so measurement
        // captures the full single-line button width, not a wrapped one)
        var maxW = 0;
        group.forEach(function (a) {
          a.style.width = 'auto';
          a.style.whiteSpace = 'nowrap';
          var w = a.getBoundingClientRect().width;
          if (w > maxW) maxW = w;
        });
        // Apply equal width — but cap to parent's inner width to
        // prevent overflow on mobile viewports.
        var parent = group[0].parentElement;
        var parentInnerW = parent ? parent.clientWidth - (parseInt(getComputedStyle(parent).paddingLeft)||0) - (parseInt(getComputedStyle(parent).paddingRight)||0) : maxW;
        var finalW = Math.min(Math.ceil(maxW), parentInnerW);
        // If natural single-line width fits the parent, keep nowrap
        // at that width. Otherwise go full-width and allow balanced
        // two-line wrap — readable text, no orphaned word, no truncation.
        var fits = Math.ceil(maxW) <= parentInnerW;
        var finalBtnW = fits ? Math.ceil(maxW) : parentInnerW;
        group.forEach(function (a) {
          a.style.setProperty('width', finalBtnW + 'px', 'important');
          a.style.setProperty('max-width', '100%', 'important');
          a.style.setProperty('display', 'inline-block', 'important');
          a.style.setProperty('box-sizing', 'border-box', 'important');
          a.style.setProperty('text-align', 'center', 'important');
          a.style.removeProperty('overflow');
          a.style.removeProperty('text-overflow');
          if (fits) {
            a.style.setProperty('white-space', 'nowrap', 'important');
            a.style.removeProperty('line-height');
          } else {
            a.style.setProperty('white-space', 'normal', 'important');
            a.style.setProperty('text-wrap', 'balance', 'important');
            a.style.setProperty('line-height', '1.25', 'important');
            a.style.setProperty('padding-left', '12px', 'important');
            a.style.setProperty('padding-right', '12px', 'important');
          }
        });
      });
    });
  }

  function updateDrawerHeaderOffset() {
    // Only measure when the drawer is CLOSED (otherwise the drawer covers
    // the header and we'd measure wrong). Skip entirely on non-mobile.
    if (window.innerWidth > 989) return;
    var details = document.querySelector('header-drawer details');
    if (details && details.hasAttribute('open')) return;
    var header = document.querySelector('.header-wrapper') ||
                 document.querySelector('header.header') ||
                 document.querySelector('.section-header');
    if (!header) return;
    var h = Math.round(header.getBoundingClientRect().height);
    if (h > 0 && h < 500) {
      // Add 16px breathing room below the header. Sanity-cap at 500px.
      document.documentElement.style.setProperty('--drawer-header-offset', (h + 16) + 'px');
    }
  }

  function fixDrawerHome() {
    updateDrawerHeaderOffset();
    // When the mobile drawer opens, scroll it to the very top so the
    // first link (Home) is guaranteed visible — iOS Safari sometimes
    // preserves an old scroll position inside the drawer.
    var details = document.querySelector('header-drawer details.menu-drawer-container, header-drawer details');
    if (!details) return;
    var inner = details.querySelector('.menu-drawer__inner-container');
    if (!inner) return;
    // Observe open/close via the 'menu-opening' class Dawn toggles
    var observer = new MutationObserver(function () {
      if (details.hasAttribute('open')) {
        // Reset scroll to top after browser finishes the transform
        requestAnimationFrame(function () {
          inner.scrollTop = 0;
          setTimeout(function () { inner.scrollTop = 0; }, 50);
          setTimeout(function () { inner.scrollTop = 0; }, 350);
        });
      }
    });
    observer.observe(details, { attributes: true, attributeFilter: ['open', 'class'] });
    // Also wire the summary click directly as a belt-and-suspenders
    var summary = details.querySelector('summary.header__icon--menu');
    if (summary) {
      summary.addEventListener('click', function () {
        updateDrawerHeaderOffset();
        setTimeout(function () { inner.scrollTop = 0; }, 50);
        setTimeout(function () { inner.scrollTop = 0; }, 350);
      });
    }
  }

  // Partner page (/pages/wholesale): the hero CTA has two buttons
  // (Request Sample Box + Partner Portal) wrapped in a div with
  // inline "flex-direction: column !important" that stacks them.
  // Force row direction on desktop/tablet; keep column on mobile.
  // Partner page (/pages/wholesale): restore the original parent
  // flex-direction if we previously touched it, then wrap the two
  // CTA buttons in their own flex-row div so they sit side-by-side
  // on desktop without disturbing the heading/paragraph above them.
  function fixPartnerCtaButtons() {
    var sampleLink = document.querySelector('a[href*="sample-box-form"]');
    var portalLink = document.querySelector('a[href*="partners.lazarfamilybakehouse"]');
    if (!sampleLink || !portalLink) return;
    // If we've already wrapped them in a custom row, just update its styles.
    var existingRow = document.querySelector('[data-cta-btn-row="1"]');
    if (!existingRow) {
      // If the two anchors share the same parent, create a wrapper div
      // and move both anchors into it in-place of the first anchor.
      var parent = sampleLink.parentElement;
      if (portalLink.parentElement !== parent) return;
      // Undo any previous parent-level flex-direction override (from an
      // earlier version of this fix) by removing that property.
      parent.style.removeProperty('flex-direction');
      var row = document.createElement('div');
      row.setAttribute('data-cta-btn-row', '1');
      parent.insertBefore(row, sampleLink);
      row.appendChild(sampleLink);
      row.appendChild(portalLink);
      existingRow = row;
    }
    // Apply row styles based on viewport width
    if (window.innerWidth >= 750) {
      existingRow.style.cssText =
        'display:flex !important;flex-direction:row !important;' +
        'flex-wrap:wrap !important;gap:14px !important;' +
        'justify-content:center !important;align-items:center !important;' +
        'width:100% !important;margin-top:8px !important;';
      sampleLink.style.setProperty('flex', '0 0 auto', 'important');
      sampleLink.style.setProperty('width', 'auto', 'important');
      portalLink.style.setProperty('flex', '0 0 auto', 'important');
      portalLink.style.setProperty('width', 'auto', 'important');
    } else {
      existingRow.style.cssText =
        'display:flex !important;flex-direction:column !important;' +
        'gap:12px !important;align-items:center !important;' +
        'width:100% !important;margin-top:8px !important;';
      sampleLink.style.removeProperty('flex');
      sampleLink.style.removeProperty('width');
      portalLink.style.removeProperty('flex');
      portalLink.style.removeProperty('width');
    }
  }

  function outlineProductBadges() {
    // Replace colorful emoji in product page badge spans with
    // clean outlined Unicode icons styled in brand brown.
    var map = {
      '\uD83C\uDF1F': '\u2606',  // 🌟 → ☆ (white star)
      '\u2B50':       '\u2606',  // ⭐ → ☆
      '\uD83C\uDF81': '\u25A1',  // 🎁 → □ (box outline)
      '\uD83E\uDD4B': '\u25A1',  // 🥋 → □
      '\u2764\uFE0F': '\u2661',  // ❤️ → ♡ (heart outline)
      '\u2764':       '\u2661',  // ❤ → ♡
      '\u2744\uFE0F': '\u2743',  // ❄️ → ❃ (snowflake outline)
      '\u2744':       '\u2743',  // ❄ → ❃
      '\uD83C\uDF89': '\u2727',  // 🎉 → ✧ (sparkle outline)
      '\uD83C\uDFC6': '\u2606',  // 🏆 → ☆
      '\uD83C\uDF6A': '\u25CB',  // 🍪 → ○ (circle outline)
      '\uD83E\uDDC1': '\u25CB'   // 🧁 → ○
    };
    var spans = document.querySelectorAll('span');
    for (var i = 0; i < spans.length; i++) {
      var txt = spans[i].textContent || '';
      var changed = false;
      for (var emoji in map) {
        if (txt.indexOf(emoji) > -1) {
          txt = txt.replace(emoji, map[emoji]);
          changed = true;
        }
      }
      if (changed) {
        spans[i].textContent = txt;
        spans[i].style.setProperty('color', '#6b4a32', 'important');
        spans[i].style.setProperty('font-size', '13px', 'important');
        spans[i].style.setProperty('font-family', 'Nunito, sans-serif', 'important');
        spans[i].style.setProperty('letter-spacing', '0.02em', 'important');
      }
    }
  }

  function highlightPartnerColumnHeaders() {
    // Give "Product Lineup" and "Why Partners Choose Us" a dark-brown
    // banner header so they stand out as column titles.
    var titles = ['Product Lineup', 'Why Partners Choose Us'];
    var heads = document.querySelectorAll('h3, h2');
    for (var i = 0; i < heads.length; i++) {
      var t = (heads[i].textContent || '').trim();
      if (titles.indexOf(t) > -1) {
        var h = heads[i];
        h.style.setProperty('background', '#2d1b0e', 'important');
        h.style.setProperty('color', '#fdf6ee', 'important');
        h.style.setProperty('font-family', '"Playfair Display", serif', 'important');
        h.style.setProperty('font-weight', '400', 'important');
        h.style.setProperty('font-size', '20px', 'important');
        h.style.setProperty('letter-spacing', '0.04em', 'important');
        h.style.setProperty('padding', '14px 20px', 'important');
        h.style.setProperty('margin', '-32px -28px 28px -28px', 'important');
        h.style.setProperty('text-align', 'center', 'important');
        h.style.setProperty('border-radius', '0', 'important');
        h.style.setProperty('display', 'block', 'important');
      }
    }
  }

  function squareOffContentCards() {
    // Strip rounded corners from inline-styled content cards so the
    // partner page matches the home page's square/editorial style.
    // Excludes form inputs/buttons (they keep their small radius).
    var rtes = document.querySelectorAll('.rte');
    rtes.forEach(function (rte) {
      var all = rte.querySelectorAll('div, section, article, aside');
      all.forEach(function (el) {
        // Skip anything that is or lives inside a form control
        if (el.closest('form, input, textarea, select, button')) return;
        var cs = getComputedStyle(el);
        var br = cs.borderRadius;
        if (br && br !== '0px' && br !== '0px 0px 0px 0px') {
          el.style.setProperty('border-radius', '0', 'important');
        }
      });
    });
  }

  function renameMandelBread8oz() {
    // Rename "Mandel Bread — 8oz Bag" heading to "Mandelbites"
    // on the wholesale page Product Lineup.
    var heads = document.querySelectorAll('h4, h3');
    for (var i = 0; i < heads.length; i++) {
      var txt = (heads[i].textContent || '').trim();
      // Match any form: em-dash, hyphen, en-dash + 8oz/8 oz
      if (/^Mandel\s*Bread\s*[—–-]\s*8\s*oz/i.test(txt)) {
        heads[i].textContent = 'Mandelbites';
      }
    }
    // Rewrite the Individual Mandel Bread use-case line + Two-Pack tag.
    var ps = document.querySelectorAll('p, em, span, div');
    for (var j = 0; j < ps.length; j++) {
      // Only touch leaf-ish elements with short text so we don't clobber parents
      if (ps[j].children.length > 0) continue;
      var pt = (ps[j].textContent || '').trim();
      if (/hotels,\s*gift bags,?\s*and breaks/i.test(pt)) {
        ps[j].textContent = 'Single-serve portions ideal for catering and coffee shops.';
      } else if (/^No slicing\s*[·•]\s*Ready to sell$/i.test(pt)) {
        ps[j].textContent = "Coffee or tea's best friend";
      } else if (/mandel bread\s*[—–-]\s*handcrafted/i.test(pt)) {
        ps[j].textContent = "Partner with Lazar Family Bakehouse and offer your customers Denver's favorite artisan mandel bread.";
      }
    }
  }

  function trimPartnerBenefits() {
    // On /pages/wholesale, hide the 3 least important benefits so the
    // "Why Partners Choose Us" list matches the 3-item Product Lineup column.
    // Keep: Counter Ready, Flexible Minimums, 90-Day Shelf Life.
    // Hide: Weekly Delivery, Authentic Story, Easy Reorder.
    // Each benefit is a flex row: [✓ span] + [title/desc div]
    var hideTitles = ['Authentic Story', 'Easy Reorder'];
    var strongs = document.querySelectorAll('strong');
    for (var i = 0; i < strongs.length; i++) {
      var t = (strongs[i].textContent || '').trim();
      if (hideTitles.indexOf(t) > -1) {
        // Walk up: strong -> text div -> flex parent (the whole row)
        var textDiv = strongs[i].parentElement;
        if (!textDiv) continue;
        var row = textDiv.parentElement;
        if (row && row.tagName === 'DIV' && row.children.length <= 3) {
          // Verify this row contains a ✓ sibling (safety check)
          var hasCheck = false;
          for (var k = 0; k < row.children.length; k++) {
            if (row.children[k].textContent.indexOf('✓') > -1) { hasCheck = true; break; }
          }
          if (hasCheck) {
            row.style.setProperty('display', 'none', 'important');
          } else {
            textDiv.style.setProperty('display', 'none', 'important');
          }
        }
      }
    }
  }

  function runAll() {
    try { fixRteContainers(); } catch (e) { console.warn('fixRteContainers:', e); }
    try { fixInlineGrids(); } catch (e) { console.warn('fixInlineGrids:', e); }
    try { equalizeButtonGroups(); } catch (e) { console.warn('equalizeButtonGroups:', e); }
    try { fixDrawerHome(); } catch (e) { console.warn('fixDrawerHome:', e); }
    try { fixPartnerCtaButtons(); } catch (e) { console.warn('fixPartnerCtaButtons:', e); }
    try { trimPartnerBenefits(); } catch (e) { console.warn('trimPartnerBenefits:', e); }
    try { renameMandelBread8oz(); } catch (e) { console.warn('renameMandelBread8oz:', e); }
    try { squareOffContentCards(); } catch (e) { console.warn('squareOffContentCards:', e); }
    try { outlineProductBadges(); } catch (e) { console.warn('outlineProductBadges:', e); }
    try { highlightPartnerColumnHeaders(); } catch (e) { console.warn('highlightPartnerColumnHeaders:', e); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAll);
  } else {
    runAll();
  }
  window.addEventListener('load', runAll);

  // Re-run on resize (debounced)
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(runAll, 150);
  });
})();
